import styles from './data-filter.module.css';

type Callback = (data: {}) => boolean;

export class DataFilterApp {
    
    private items: (HTMLFieldSetElement | HTMLInputElement)[];
    private callbacks: Callback[] = [];
    private filterItems: string[] = [];
    private itemClass: string;

    constructor(itemClass: string ) {
        this.itemClass = itemClass;
        this.items = Array.from(document.querySelectorAll(`[${itemClass}]`)) as (HTMLFieldSetElement | HTMLInputElement)[];
    }

    public addFilter(filterItem: string|string[]): void {
        (typeof filterItem == 'string')
            ? this.filterItems.push(filterItem)
            : this.filterItems.push(...filterItem);
    }
    public addFilterCallback(callback: Callback): void {
        this.callbacks.push(callback);
        // const filterInput = document.getElementById(filterInputId) as HTMLInputElement;
        // if (!filterInput) throw new Error(`Filter input with id "${filterInputId}" not found`);

        // ["input", "change"].forEach(event => {
        //     filterInput.addEventListener("input", () => {
        //         this.render();
        //     });
        // });
    }

    /**
     * フィルタリング処理
     * @param query 検索ワード（部分一致でマッチング）
     */
    public render(conditions: string[]) {
        this.items.forEach(item => {
            const filterData = item.getAttribute(`${this.itemClass}`);
            if (!filterData) {
                item.style.display = "none";
                return;
            }
            if (!this.callbacks) {
                item.style.display = "block";
                return;
            }

            try {
                const dataObject = JSON.parse(filterData) as Record<string, string>;
                let display = true;
                this.callbacks.forEach((callback) => {
                    display = display && callback(dataObject);
                });
                this.filterItems.forEach((item) => {
                    if (typeof dataObject[item] == 'string') {
                        display = display && dataObject[item].includes(conditions[item]);
                    } else {
                        display = display && dataObject[item]==conditions[item];
                    }
                });
                item.style.display = display ? "block" : "none"
                item.disabled = ! display;
            } catch (error) {
                console.error(`Invalid JSON in data-filter-data:`, filterData);
                item.style.display = "none"; // パースできないデータは非表示にする
            }
        });
    }
}


(window as any).DataFilterApp = DataFilterApp;
